<style lang="less" scoped>
.cardList {position: relative;width: 350px;height: 240px;text-align: left;font-family: AlibabaPuHuiTi-Regular;}
ul {list-style: none;height: 300px;overflow: hidden;}
.first{color: rgb(252, 24, 24);font-size: 13px;vertical-align: top;}
.second{color: rgb(250, 139, 11);font-size: 13px;vertical-align: top;}
.third{color: rgb(224, 174, 10);font-size: 13px;vertical-align: top;}
li {margin-top: 15px;width: 350px;font-size: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
span:hover {color: #13569e}
span{letter-spacing: 1px;cursor: pointer;}
.others{margin-left: 20px;}
</style>

<!--何宽  2021.6.10
    该组件使用场景：将标题以列表的形式纵向展示，只展示8列，鼠标点击 标题，将 相应的对象 传递给父组件 -->
<template>
  <ul class="list">
    <li v-for="(item, index) in hotNewsList" :key="index" @click="clickHotNews(item)">
      <span class="first" v-if="index===0">①</span><span v-if="index===0"> {{ item.title }} </span>
      <span class="second" v-if="index===1">②</span><span v-if="index===1"> {{ item.title }} </span>
      <span class="third" v-if="index===2">③</span><span v-if="index===2"> {{ item.title }} </span>
      <span class="others" v-if="index > 2 && index < 8"> {{ item.title }} </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['hotNewsList'],
  data()
  {
    return {}
  },
  methods: {
    // 点击列表项，将选中的 列表对象 传递给父组件
    clickHotNews(item)
    {
      this.$emit('clickHotNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/HotNewsList.vue